var _path, _g, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgVi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.337H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#ffda44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M284.986 204.557c0-16.008-12.977-28.986-28.986-28.986-16.008 0-28.986 12.978-28.986 28.986h-63.768c0 15.761 13.729 28.538 29.49 28.538h-.949c0 15.762 12.777 28.541 28.54 28.541 0 13.955 10.023 25.551 23.259 28.031l-.075.167h24.977l-.073-.167c13.237-2.48 23.26-14.076 23.26-28.031 15.763 0 28.54-12.778 28.54-28.541h-.951c15.761 0 29.49-12.778 29.49-28.538h-63.768z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M243.258 286.877l-17.972 40.575A81.349 81.349 0 00256 333.449a81.355 81.355 0 0030.713-5.997l-17.971-40.575h-25.484z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M218.899 218.811v49.928c0 28.399 37.101 37.101 37.101 37.101s37.101-8.702 37.101-37.101v-49.928h-74.202z",
  fill: "#f0f0f0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M126.719 257.195l20.066 56.123 19.857-56.123h15.154l-28.95 74.203h-12.123l-29.158-74.203h15.154zm233.165 74.204v-74.203h14.423v74.203h-14.423z",
  fill: "#338af3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M233.739 234.935v60.503c5.101 3.753 10.588 6.337 14.84 7.989v-68.492h-14.84zm44.522 0v60.503c-5.101 3.753-10.588 6.337-14.84 7.989v-68.492h14.84z",
  fill: "#d80027"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M218.902 218.808h74.207v23.541h-74.207z"
})));

export default SvgVi;